import { render, staticRenderFns } from "./ProfitGroups.vue?vue&type=template&id=fb7997b4&scoped=true"
import script from "./ProfitGroups.vue?vue&type=script&lang=js"
export * from "./ProfitGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb7997b4",
  null
  
)

export default component.exports